/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import './menu.css';
import { FaSolarPanel } from 'react-icons/fa';
import { IoMdAlarm } from 'react-icons/io';
import { BsSun, BsLightning } from 'react-icons/bs';
import { BiSend, BiLogOut } from 'react-icons/bi';
import { RiTerminalWindowLine } from 'react-icons/ri';
import { GiPowerGenerator } from "react-icons/gi";
import { CiViewTable } from "react-icons/ci";
import { BsClipboardData } from "react-icons/bs";
import { useTranslation } from 'react-i18next';
import logo from '../../images/Login/adinsefull600.png';
function Menu() {
    var screens = JSON.parse(sessionStorage.getItem('ScreenConfiguration'));
    //Recogemos el estado de las pantallas, esto es si se van a ver o no
    const [enabledMap, setEnabledMap] = useState('');
    const { t, i18n } = useTranslation();
    const [enabledCommands, setEnabledCommands] = useState('');
    const [selectedLanguageFilter, setSelectedLanguageFilter] = useState(i18n.language);
    const [enabledInv, setEnabledInv] = useState('');
    const [enabledMeteo, setEnabledMeteo] = useState('');
    const [enabledEM, setEnabledEM] = useState('');
    const [enabledPLC, setEnabledPLC] = useState('');
    const [enabledAlarms, setEnabledAlarms] = useState('');
    const [enabledST, setEnabledST] = useState('');

    async function checkSession() {
        const response = await fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/sessions/sessionStatus", { method: 'GET', credentials: 'include' });
        if (response.status === 401) {
            sessionStorage.clear();
            window.location.reload();
        }
    }

    let number = 0;
    useEffect(() => {
        checkSession();
        setInterval(function () {
            number++;
            checkSession();
        }, 10000)
    }, [number]);

    const cerrarSesion = () => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + '/sessions/logout', {
            method: 'DELETE',
            credentials: 'include'
        })
            .then(response => { sessionStorage.removeItem("configuration"); sessionStorage.clear(); window.location.reload(); })
            .catch(e => { console.error(e); })
    }


    useEffect(() => {
        for (let i = 0; i < screens.length; i++) {
            switch (screens[i].Screen) {
                case 'Map':
                    if (screens[i].Enabled === false) {
                        setEnabledMap('none');
                    }
                    break;
                case 'Commands':
                    if (screens[i].Enabled === false) {
                        setEnabledCommands('none');
                    }
                    break;
                case 'Inverter':
                    if (screens[i].Enabled === false) {
                        setEnabledInv('none');
                    }
                    break;
                case 'Meteo':
                    if (screens[i].Enabled === false) {
                        setEnabledMeteo('none');
                    }
                    break;
                case 'EnergyMeter':
                    if (screens[i].Enabled === false) {
                        setEnabledEM('none');
                    }
                    break;
                case 'PLC':
                    if (screens[i].Enabled === false) {
                        setEnabledPLC('none');
                    }
                    break;
                case 'Logs':
                    if (screens[i].Enabled === false) {
                        setEnabledAlarms('none');
                    }
                    break;
                case 'Substation':
                    if (screens[i].Enabled === false) {
                        setEnabledST('none');
                    }
                    break;
                default:
                    console.log()
                    break;
            }
        }
    }, []);

    const handleLanguageFilterChange = (e) => {
        const newLang = e.target.value;
        setSelectedLanguageFilter(newLang);
        i18n.changeLanguage(newLang);
    };
    const languages = [
        { Id: 'en', Language: t('languages.en'), Name: "English" },
        { Id: 'pt', Language: t('languages.pt'), Name: "Portuguese" },
        { Id: 'es', Language: t('languages.es'), Name: "Spanish" },
        { Id: 'it', Language: t('languages.it'), Name: "Italian" }
    ];
    return (<>
        <div className='div-menu-component' id='menu-large-width'style={{ display: 'flex', alignItems: 'center' }}>
            <div className='logo-parque'>
                <img id="logo" style={{ width: "8rem", height: "2.5rem", marginLeft: "0rem", marginRight: "0rem" }} src={logo} alt="logo" />
            </div>
            <a className='route-button' onClick={() => { window.open("/#/mapa", "_self") }} ><FaSolarPanel /> {t('scada.menu.park')}</a>
            <a className='route-button' style={{ display: enabledCommands }} onClick={() => { window.open("/#/comandos", "_self") }}><BiSend /> {t('scada.menu.commands')}</a>
            <a className='route-button' style={{ display: enabledInv }} onClick={() => { window.open("/#/listaInv", "_self") }}><CiViewTable /> {t('scada.menu.investors')}</a>
            <a className='route-button' style={{ display: enabledMeteo }} onClick={() => { window.open("/#/comparativas", "_self") }}><BsClipboardData /> {t('scada.menu.comparatives')}</a>
            <a className='route-button' style={{ display: enabledMeteo }} onClick={() => { window.open("/#/meteo", "_self") }}><BsSun /> {t('scada.menu.meteo')}</a>
            <a className='route-button' style={{ display: enabledEM }} onClick={() => { window.open("/#/analizador", "_self") }}><BsLightning /> {t('scada.menu.analyzer')}</a>
            <a className='route-button' style={{ display: enabledPLC }} onClick={() => { window.open("/#/plc", "_self") }}><RiTerminalWindowLine /> {t('scada.menu.plc')}</a>
            <a className='route-button' style={{ display: enabledST }} onClick={() => { window.open("/#/substation", "_self") }}><GiPowerGenerator /> {t('scada.menu.substation')}</a>
            <a className='route-button' style={{ display: enabledAlarms }} onClick={() => { window.open("/#/alarmas", "_self") }}><IoMdAlarm /> {t('scada.menu.alarms')}</a>
            <a className='route-button' style={{ display: enabledMeteo, marginRight: 'auto'}} onClick={() => { window.open("/#/historicos", "_self") }}><BsClipboardData /> {t('scada.menu.historical')}</a>
            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                <select
                    className="form-select language-select"
                    value={selectedLanguageFilter || ""}
                    onChange={handleLanguageFilterChange}
                    style={{ minWidth: "140px", maxWidth: "160px", marginRight: "10px" }}
                >
                    {languages.map(lang => (
                        <option key={lang.Id} value={lang.Id}>{lang.Name}</option>
                    ))}
                </select>
                <a className='logout-button' onClick={cerrarSesion} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><BiLogOut /> {t('scada.menu.logout')}</a>
            </div>
        </div>
        <div className='div-menu-component' id='menu-short-width'>
            <a className='route-button' onClick={() => { window.open("/#/mapa", "_self") }}><FaSolarPanel /></a>
            <a className='route-button' style={{ display: enabledCommands }} onClick={() => { window.open("/#/comandos", "_self") }}><BiSend /></a>
            <a className='route-button' style={{ display: enabledInv }} onClick={() => { window.open("/#/listaInv", "_self") }}><CiViewTable /></a>
            <a className='route-button' style={{ display: enabledMeteo }} onClick={() => { window.open("/#/comparativas", "_self") }}><BsClipboardData /></a>
            <a className='route-button' style={{ display: enabledMeteo }} onClick={() => { window.open("/#/meteo", "_self") }}><BsSun /></a>
            <a className='route-button' style={{ display: enabledEM }} onClick={() => { window.open("/#/analizador", "_self") }}><BsLightning /></a>
            <a className='route-button' style={{ display: enabledPLC }} onClick={() => { window.open("/#/plc", "_self") }}><RiTerminalWindowLine /></a>
            <a className='route-button' style={{ display: enabledST }} onClick={() => { window.open("/#/substation", "_self") }}><GiPowerGenerator /></a>
            <a className='route-button' style={{ display: enabledAlarms }} onClick={() => { window.open("/#/alarmas", "_self") }}><IoMdAlarm /></a>
            <a className='route-button' style={{ display: enabledMeteo }} onClick={() => { window.open("/#/historicos", "_self") }}><BsClipboardData /></a>
            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                <select
                    className="form-select language-select"
                    value={selectedLanguageFilter || ""}
                    onChange={handleLanguageFilterChange}
                    style={{ minWidth: "140px", maxWidth: "160px", marginRight: "10px" }}
                >
                    {languages.map(lang => (
                        <option key={lang.Id} value={lang.Id}>{lang.Name}</option>
                    ))}
                </select>
                <a className='logout-button' onClick={cerrarSesion} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><BiLogOut /></a>
            </div>
        </div>
    </>
    );

}

export default Menu